import type { ModuleInfo } from '@open-mercato/shared/modules/registry'

export const metadata: ModuleInfo = {
  name: 'search',
  title: 'Search',
  version: '0.1.0',
  description: 'Unified search module with pluggable strategies (Meilisearch, Vector, Tokens).',
  author: 'FreightTech Team',
}
